import React, { useState } from 'react'
import './Qualification.css';

const Qualification = () => {

    const [toggleState, setToggleState] = useState(1);

    const toggleTab = (index) => {
        setToggleState(index);
    };

    return (
        <section className="qualification section">
            <h2 className="section__title">Qualification</h2>
            <span className="section__subtitle">My personal journey</span>

            <div className="qualification__container container">
                {/* Tabs for Education and Experience */}
                <div className="qualification__tabs">
                    <div className={toggleState === 1 ? "qualification__button qualification__active button--flex" : "qualification__button  button--flex"} onClick={() => toggleTab(1)}>
                        <i className="uil uil-graduation-cap qualification__icon"></i> Education
                    </div>

                    <div className={toggleState === 2 ? "qualification__button qualification__active button--flex" : "qualification__button  button--flex"} onClick={() => toggleTab(2)}>
                        <i className="uil uil-briefcase-alt qualification__icon"></i> Experience
                    </div>
                </div>

                {/* Sections for Education and Experience */}
                <div className="qualification__sections">
                    {/* Education Section */}
                    <div className={toggleState === 1 ? "qualification__content qualification__content-active" : "qualification__content"}>
                        <div className="qualification__data">
                            <div>
                                <h3 className="qualification__title">B.TECH</h3>
                                <span className="qualification__subtitle">KIET - Korangi</span>
                                <div className="qualification__calender">
                                    <i className="uil uil-calender-alt"></i> 2021 - 2025
                                </div>
                            </div>
                            <div>
                                <span className="qualification__rounder"></span>
                                <span className="qualification__line"></span>
                            </div>
                        </div>

                        <div className="qualification__data">
                            <div></div>
                            <div>
                                <span className="qualification__rounder"></span>
                                <span className="qualification__line"></span>
                            </div>
                            <div>
                                <h3 className="qualification__title">Intermediate</h3>
                                <span className="qualification__subtitle">SASI - Mandapeta</span>
                                <div className="qualification__calender">
                                    <i className="uil uil-calender-alt"></i> 2019 - 2021
                                </div>
                            </div>
                        </div>

                        <div className="qualification__data">
                            <div>
                                <h3 className="qualification__title">SSC</h3>
                                <span className="qualification__subtitle">BHASHYAM - RCPM</span>
                                <div className="qualification__calender">
                                    <i className="uil uil-calender-alt"></i> 2019
                                </div>
                            </div>
                            <div>
                                <span className="qualification__rounder"></span>
                                <span className="qualification__line"></span>
                            </div>
                        </div>

                        {/* <div className="qualification__data">
                            <div></div>
                            <div>
                                <span className="qualification__rounder"></span>
                                <span className="qualification__line"></span>
                            </div>
                            <div>
                                <h3 className="qualification__title">UX Expert</h3>
                                <span className="qualification__subtitle">Spain - Institute</span>
                                <div className="qualification__calender">
                                    <i className="uil uil-calender-alt"></i> 2021 - 2022
                                </div>
                            </div>
                        </div> */}
                    </div>

                    {/* Experience Section */}
                    <div className={toggleState === 2 ? "qualification__content qualification__content-active" : "qualification__content"}>
                        <div className="qualification__data">
                            <div>
                                <h3 className="qualification__title">Full Stack Developer</h3>
                                <span className="qualification__subtitle">Next Crest Media</span>
                                <div className="qualification__calender">
                                    <i className="uil uil-calender-alt"></i> SEP 2025 - PRESENT
                                </div>
                            </div>
                            <div>
                                <span className="qualification__rounder"></span>
                                <span className="qualification__line"></span>
                            </div>
                        </div>

                        <div className="qualification__data">
                            <div></div>
                            <div>
                                <span className="qualification__rounder"></span>
                                <span className="qualification__line"></span>
                            </div>
                            <div>
                                <h3 className="qualification__title">Python Full Stack Intern</h3>
                                <span className="qualification__subtitle">Infosys Springboard</span>
                                <div className="qualification__calender">
                                    <i className="uil uil-calender-alt"></i> DEC 2025 - PRESENT
                                </div>
                            </div>
                        </div>

                        <div className="qualification__data">
                            <div>
                               <h3 className="qualification__title">Senior Developer Intern</h3>
                                <span className="qualification__subtitle">RCTS - IIIT, HYD</span>
                                <div className="qualification__calender">
                                    <i className="uil uil-calender-alt"></i> AUG 2024 - APR 2025
                                </div>
                            </div>
                            <div>
                                <span className="qualification__rounder"></span>
                                <span className="qualification__line"></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Qualification;
